import { useContext } from 'react';
import { filterDataContext } from '../FilterDataProvider';
import Item from './Item';
import helpers from '../../utilities/helpers';

// A heading is a group anyone can tick: "United States (all States)" and each
// continent. Everything else in the list is a member of one of them.
const HEADINGS = new Set([
   'United States (all States)',
   'Africa', 'Asia', 'Europe', 'North America', 'Oceania', 'South America',
   'International / worldwide',
]);

export default function Filter({ pkey, category }) {
   let { allFiltersOptions, useGetFormatedFiltersFromFilterData, filterData } =
      useContext(filterDataContext);
   let { turnObjectPropertiesIntoArrayOfNames } = helpers;
   let avalibleItems = allFiltersOptions
      ? turnObjectPropertiesIntoArrayOfNames(allFiltersOptions[category])
      : [];

   return (
      <div className='ais-RefinementList'>
         <ul className='ais-RefinementList-list'>
            {avalibleItems.map((itemName, i) => {
               if (itemName === 'buffer') return;
               return (
                  <Item
                     initalySelected={false}
                     name={itemName}
                     pkey={pkey}
                     ckey={i}
                     category={category}
                     isHeading={HEADINGS.has(itemName)}
                     key={i}
                  />
               );
            })}
         </ul>
      </div>
   );
}
